'use strict';

var Misc = require('utils/misc');
var i18n = require('utils/i18n');

// The timemodel is responsible for loading, providing, altering and saving data from (an to) the backbone model.
var TimeModel = {};

TimeModel.TimeModes = {
    AllDaysSame: 1,
    WorkWeek: 2,
    AllDaysDifferent: 3,
};

TimeModel.Days = {
    Monday: 0,
    Tuesday: 1,
    Wednesday: 2,
    Thursday: 3,
    Friday: 4,
    Saturday: 5,
    Sunday: 6,
};

TimeModel.TimeModeLabels = {};

// intialize initializes time model
TimeModel.initialize = function (name, data, timeProgramNumber, width, inconsistent) {
    this.name = name;
    this.inconsistent = inconsistent;

    if (inconsistent) {
        return;
    }

    this.TimeModeLabels = {
        1: [{ label: i18n.TR('Mo') + ' - ' + i18n.TR('So'), ID: TimeModel.Days.Monday }],
        2: [
            { label: i18n.TR('Mo') + ' - ' + i18n.TR('Fr'), ID: TimeModel.Days.Monday },
            { label: i18n.TR('Sa') + ' - ' + i18n.TR('So'), ID: TimeModel.Days.Saturday },
        ],
        3: [
            { label: i18n.TR('Mo'), ID: TimeModel.Days.Monday },
            { label: i18n.TR('Di'), ID: TimeModel.Days.Tuesday },
            { label: i18n.TR('Mi'), ID: TimeModel.Days.Wednesday },
            { label: i18n.TR('Do'), ID: TimeModel.Days.Thursday },
            { label: i18n.TR('Fr'), ID: TimeModel.Days.Friday },
            { label: i18n.TR('Sa'), ID: TimeModel.Days.Saturday },
            { label: i18n.TR('So'), ID: TimeModel.Days.Sunday },
        ],
    };

    this.timeProgramNumber = timeProgramNumber;
    this.inconsistent = false;

    this.data = $.extend(true, [], data);
    this.mode = getModeFromData(this.data);
    this.width = width || 453;
};

// getModeFromData determines the current mode from the given data
function getModeFromData(data) {
    // if either the weekend or the week is inhomogen, than all days are are treated as different
    if (
        !Misc.arraysEqual(data.slice(TimeModel.Days.Saturday)) ||
        !Misc.arraysEqual(data.slice(TimeModel.Days.Monday, TimeModel.Days.Saturday))
    ) {
        return TimeModel.TimeModes.AllDaysDifferent;
    }
    if (Misc.arraysEqual([data[TimeModel.Days.Monday], data[TimeModel.Days.Saturday]])) {
        return TimeModel.TimeModes.AllDaysSame;
    }
    return TimeModel.TimeModes.WorkWeek;
}

// setMode overrides the current mode and modifies the seven timelines to reflect the changes made
// (In the case allDaysdifferent, nothing is changed.)
TimeModel.setMode = function (mode) {
    switch (mode) {
        case this.TimeModes.AllDaysSame:
            for (var i = 1; i < 7; ++i) {
                this.data[i] = this.data[TimeModel.Days.Monday].slice();
            }
            break;
        case this.TimeModes.WorkWeek:
            for (var i = 1; i < 5; ++i) {
                this.data[i] = this.data[TimeModel.Days.Monday].slice();
            }
            this.data[TimeModel.Days.Sunday] = this.data[TimeModel.Days.Saturday].slice();
            break;
    }
    this.mode = mode;
};

// returns an array of objects consisting of a label, an id and the data used for drawing
TimeModel.getTimelinesToDraw = function () {
    if (this.inconsistent) {
        return undefined;
    }

    var modelToDraw = [];
    var iterationArrays = { 1: [0], 2: [0, 5], 3: [0, 1, 2, 3, 4, 5, 6] };
    var mode = this.mode;
    var storedModel = this;
    $.each(iterationArrays[mode], function (arrPos, index) {
        modelToDraw.push({
            label: storedModel.TimeModeLabels[mode][arrPos].label,
            ID: '' + storedModel.TimeModeLabels[mode][arrPos].ID + '-' + storedModel.timeProgramNumber,
            data: storedModel.data[index],
        });
    });
    return modelToDraw;
};

// expects the day to be set and a set of intervals of the form: [{start: <starttime>, end:<endTime>}]
// 'start' and 'end' may take values in the range [0, ... , 96]. Each number equals one quarter of an hour.
// Example:
// [{start:16, end: 48}, {start: 81:96}] corresponds to the time intervals:
// 04:00 - 12:00 and 20:15 - 24:00
TimeModel.setIntervals = function (day, intervals) {
    // sort intervals
    intervals.sort(function (a, b) {
        return a.start - b.start;
    });
    var intervalEndings = [];
    $.each(intervals, function (index, interval) {
        intervalEndings.push(interval.start);
        intervalEndings.push(interval.end);
    });
    intervalEndings.push(96);
    var currentStart = 0;
    var state = 0;
    for (var k = 0; k < intervalEndings.length; k++) {
        for (var i = currentStart; i < intervalEndings[k]; i++) {
            this.data[day][i] = state;
        }
        state = (state + 1) % 2;
        currentStart = intervalEndings[k];
    }
    // depending on the current mode override some of the days to keep the current mode consistent
    this.setMode(this.mode);
};

module.exports = TimeModel;
